import { normalizarData, normalizarValor } from '../../utils/index';

/**
 * Normaliza os nomes das colunas para facilitar a busca (remove acentos, espaços extras, minúsculas).
 */
const superNormalize = (h) => {
    return String(h || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();
};

/**
 * Retorna TRUE se o array de dados se parecer com
 * um arquivo de Recebimentos/Repasses da PagSeguro.
 */
export const detectar = (dadosArray) => {
    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const cleanRow = linha.map(superNormalize);
        
        // Verifica assinatura exclusiva da PagSeguro
        if (
            cleanRow.includes('data prevista de liberacao') && 
            cleanRow.includes('valor liquido') &&
            cleanRow.includes('codigo da venda')
        ) {
            return true;
        }
    }
    return false;
};

/**
 * Processa a planilha bruta e retorna array mapeado.
 */
export const processar = (dadosArray) => {
    let idxCabecalho = -1;
    let colMap = {};

    // 1. Localizar o cabeçalho e mapear os índices
    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const cleanRow = linha.map(superNormalize);
        
        if (
            cleanRow.includes('data prevista de liberacao') && 
            cleanRow.includes('valor liquido')
        ) {
            idxCabecalho = i;
            cleanRow.forEach((h, idx) => {
                if (h) colMap[h] = idx;
            });
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho de Repasses PagSeguro não encontrado.');
    }

    const repasses = [];
    
    // 2. Extrair dados
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        // Validar status (se houver, aceitar apenas Aprovada)
        const idxStatus = colMap['status'];
        if (idxStatus !== undefined) {
            const status = String(linha[idxStatus] || '').trim().toLowerCase();
            if (status && !status.includes('aprovada')) {
                continue;
            }
        }

        // REGRA DE OURO: Descartar Pix
        const idxFormaPagamento = colMap['forma de pagamento'];
        let formaPagamento = '';
        if (idxFormaPagamento !== undefined) {
            formaPagamento = String(linha[idxFormaPagamento] || '').trim();
            if (formaPagamento.toUpperCase() === 'PIX') {
                continue;
            }
        }

        // Data Prevista de Liberação (remover o relógio se houver)
        const idxData = colMap['data prevista de liberacao'];
        const dataStrRaw = String(linha[idxData] || '').trim();
        if (!dataStrRaw) continue;
        
        const dataStr = dataStrRaw.split(' ')[0]; // Pega apenas a data antes do espaço
        const data = normalizarData(dataStr);
        if (!data) continue;

        // Valor Líquido
        const idxValor = colMap['valor liquido'];
        const valorRaw = linha[idxValor];
        const valor = normalizarValor(valorRaw);

        // Montagem do Tipo Visível (Ex: "Crédito Visa")
        let tipoStr = 'Desconhecido';
        const idxBandeira = colMap['bandeira'];
        let bandeira = '';
        if (idxBandeira !== undefined) {
            bandeira = String(linha[idxBandeira] || '').trim();
        }

        if (formaPagamento || bandeira) {
            tipoStr = `${formaPagamento} ${bandeira}`.trim();
        }

        if (data && valor !== null && valor > 0) {
            repasses.push({
                linha: i + 1,
                data: data,
                valor: valor,
                dataOriginal: dataStr,
                tipo: tipoStr
            });
        }
    }

    return repasses;
};
